import * as React from "react";
import { forwardRef } from "react";
const SvgJobPreferences = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { focusable: "false", "aria-hidden": "true", viewBox: "0 0 24 24", fill: "#000", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M15 4v7H5.17l-.59.59-.58.58V4zm1-2H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1m5 4h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1" }));
const ForwardRef = forwardRef(SvgJobPreferences);
export { ForwardRef as ReactComponent };
